<template>
  <div>
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">
          Send Notification
        </span>
      </div>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <div class="box">
            <div>
              <div class="row col-12">
                <v-text-field
                  v-model="formData.notification_title"
                  outlined
                  dense
                  label="Title *"
                  hide-details="auto"
                  class="mb-12"
                  :rules="[validators.required]"
                  :error-messages="errors.notification_title"
                  @change="errors.notification_title = []"
                ></v-text-field>
              </div>
              <div class="row col-12">
                <!--Live from date field -->
                <v-textarea
                  v-model="formData.notification_message"
                  outlined
                  dense
                  label="Message *"
                  hide-details="auto"
                  class="mb-12"
                  :rules="[validators.required]"
                  :error-messages="errors.notification_message"
                  @change="errors.notification_message = []"
                ></v-textarea>
              </div>
            </div>

            <v-btn
              color="primary"
              block
              type="submit"
            >
              {{ 'Send' }}
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { required } from '@core/utils/validation'
import _ from 'lodash'

const blankFormData = {
	notification_title: '',
	notification_message: '',

}

export default {
	name: 'CreateNotification',
	data() {
		return {
			url: null,
			tab: 0,
			formData: _.cloneDeep(blankFormData),
			form: null,
			valid: true,
			errors: {},
			validators: { required },
			icons: { mdiClose },

		}
	},
	computed: {
		isVisible: {
			get() {
				return this.show
			},
			set(val) {
				this.$emit('update:show', val)
			},
		},

	},
	methods: {

		prepareFromData() {
			const formData = new FormData()
			Object.entries(this.formData).forEach(([key, value]) => {
				console.log(value)

				formData.append(key, value)
			})

			return formData
		},
		store() {
			const formData = this.prepareFromData()
			this.$store
				.dispatch('notification/store', formData)
				.then(response => {
					this.isVisible = false
					this.$emit('onComplete')
					this.$store.commit('app/SET_SNACKBAR_SUCCESS', response.data?.message)
					this.$router.push('/notifications')
				})
				.catch(error => {
					const { errors } = error.response.data
					if (errors) {
						this.$set(this, 'errors', errors)
						this.$set(this, 'valid', false)
					}
					this.$store.commit('app/SET_SNACKBAR_ERROR', error.response.data?.message)
				})
		},

		onSubmit() {
			if (this.valid) {
				const methodType = 'store'
				this[methodType]()
			} else {
				this.$refs.form.validate()
			}
		},

	},
}
</script>

<style scoped>

</style>
